<template>
    <main class="visual">
        <router-view/>
        <Preloader />
        <Pinchzoom />
        <Tooltip />
        <Panel />
    </main>
</template>

<style lang='scss'>
    @import "./App.scss";
</style>

<script>
import Panel from './components/Panel/Panel.vue';
import Pinchzoom from './components/Pinchzoom/Pinchzoom';
import Preloader from './components/Preloader/Preloader.vue';
import Tooltip from './components/Tooltip/Tooltip.vue';

export default {
    components: {
        Panel,
        Pinchzoom,
        Preloader,
        Tooltip
    }
};
</script>
